import { useState, type FunctionComponent, useEffect } from "react";
import { makeRipple } from "@/react/core/ripple-utils.ts";
import { assignDriverToOrder, drivers, onlineOrder0 } from "@/react/DeliveryManagementView/DeliveryManagementLogic.tsx";
import { toast } from "react-toastify";
import { useSignal } from "@/react/core/reactive.ts";
import { LL0 } from "@/react/core/I18nService";

interface BookDriverProps {
  onClose?: () => void;
}

const BookDriver: FunctionComponent<BookDriverProps> = ({ onClose }) => {
  const [selectedDriverId, setSelectedDriverId] = useSignal<string | null>(null);

  const handleSelectDriver = (driverId: string) => {
    setSelectedDriverId((prev) => (prev === driverId ? null : driverId));
  };
  useEffect(() => {
    const driverId = onlineOrder0()?.driverInfo?._id
    if (driverId) {
      setSelectedDriverId(driverId)
    }
  }, []);
  const handleConfirm = () => {
    if (!selectedDriverId()) {
      toast.warning("Please select a driver before proceeding.");
      return;
    }
    // TODO: Xử lý logic khi có driver được chọn
    console.log("Selected Driver ID:", selectedDriverId());
    assignDriverToOrder(selectedDriverId()!)
    onClose?.();
  };

  return (
    <div className="w-[400px] h-auto font-mulish overflow-hidden rounded-[8px] bg-white">
      <div className="flex flex-1 px-3 py-2 rounded-t-[8px] border-b border-[#e0e0e0]">
        <div className="flex-1 font-bold text-[16px] text-[#0051c1]">
          {LL0().deliveryManagement.selectDriverPopup()}
        </div>
        <img
          src="/icon-close-popup-icon--grey@2x.png"
          className="w-[22px] h-[22px] cursor-pointer"
          alt=""
          onClick={onClose}
        />
      </div>
      <div className="flex flex-col gap-2 p-3">
        <div className="flex flex-col gap-1">
          {drivers().map((driver, index) => (
            <div
              key={index}
              className="flex items-center gap-2 p-2 rounded border cursor-pointer"
              style={{
                borderColor: selectedDriverId() === driver._id ? "#90caf9" : "#bcbcbc",
                backgroundColor: selectedDriverId() === driver._id ? "#e3f2fd" : "#fff",
              }}
              onClick={() => handleSelectDriver(driver._id)}
            >
              <div className="flex-1 flex items-center gap-1">
                <img src={driver.avatar} className="w-5 h-5" alt="" />
                <div className="font-semibold text-[14px] text-[#394453]">{driver.name}</div>
              </div>
              {selectedDriverId() === driver._id && (
                <img src="/check-icon@2x.png" className="w-4 h-4" alt="Selected" />
              )}
            </div>
          ))}
        </div>
        <div className="flex items-center justify-center gap-1 font-bold text-[14px]">
          <div
            className="flex-1 h-8 flex items-center justify-center border border-[#1271ff] text-[#1271ff] rounded cursor-pointer"
            ref={makeRipple}
            onClick={onClose}
          >
            {LL0().onlineOrder.cancel()}
          </div>
          <div
            className="flex-1 h-8 flex items-center justify-center bg-[#1271ff] text-white rounded cursor-pointer"
            ref={makeRipple}
            onClick={handleConfirm}
          >
            {LL0().ui.ok()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookDriver;
